var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('Header'),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1),_c('Fixed'),_c('BackTop'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }